import { Component, Input, OnInit } from '@angular/core';
import { PasoWizard } from '../../../../interface/wizard-informacion.types';
import { DatosSeccionWizardEventsService } from '../../../../services/datos-seccion-wizard-events.service';
import { ButtonControlService } from '../../../../services/button-control.service';
import {EvkExpedienteModel} from '../../../../../expediente/models/evk-expediente.model';
import {EvkSeccionModel} from '../../../../../expediente/models/evk-seccion.model';

@Component({
  selector: 'lib-solicitud-firma',
  templateUrl: './solicitud-firma.component.html',
  styleUrls: ['./solicitud-firma.component.css']
})
export class SolicitudFirmaComponent implements OnInit {
  @Input()
  expediente: EvkExpedienteModel;
  @Input()
  config: PasoWizard;
  withouturl: boolean = false;
  url: string = "";
  originalUrl: string = "";
  constructor(
    public datosSeccionWizard: DatosSeccionWizardEventsService,
    private buttonControlService: ButtonControlService,
  ) {
  }

  ngOnInit(): void {
    this.buttonControlService.cambiarBotonSiguiente(false);
    console.log(this.expediente);
    // this.expediente = this.data?.paso?.inData?.expediente;
    if(this.expediente && this.expediente.firma && this.expediente.firma.url){
      this.originalUrl = this.expediente.firma.url;
    } else {
      this.withouturl = true;
    }
  }

  openUrl(){
    this.buttonControlService.cambiarBotonSiguiente(true);
    window.open(this.originalUrl);

    const response: EvkSeccionModel = {
      origen: this.config.nombre,
      propiedades: {
        url: this.originalUrl,
      },
    };
    console.log("Enviando datos a wizard");
    this.datosSeccionWizard.doneSave(response);
  }

}
